import { render, staticRenderFns } from "./nimp_logo_image.vue?vue&type=template&id=5da0b05e&scoped=true&"
import script from "./nimp_logo_image.vue?vue&type=script&lang=js&"
export * from "./nimp_logo_image.vue?vue&type=script&lang=js&"
import style0 from "./nimp_logo_image.vue?vue&type=style&index=0&id=5da0b05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da0b05e",
  null
  
)

export default component.exports